import React, { useState } from 'react';
import { AgPledgeCertificateCompanyRegistered } from '@indigo-ag/schema';
import { Fieldset, Input } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { GridContainer, InputNumberMask, utils } from 'shared';

interface PledgeCertificateRegisteredCompanyProps {
  title: string;
  companyInfo?: AgPledgeCertificateCompanyRegistered;
  onCompanyInfoUpdated: (companyInfo: AgPledgeCertificateCompanyRegistered) => void;
}

const emptyCompanyData: AgPledgeCertificateCompanyRegistered = {
  creditor: '',
  emitter: '',
  matricula: '',
  volume: 0,
  pledgeArea: 0,
  additionalInformation: ''
};

export const PledgeCertificateRegisteredCompany: React.FunctionComponent<PledgeCertificateRegisteredCompanyProps> = ({
  title,
  companyInfo = emptyCompanyData,
  onCompanyInfoUpdated
}) => {
  /**
   * State
   */
  const [companyData, setCompanyData] = useState<AgPledgeCertificateCompanyRegistered>({ ...companyInfo });

  const updateCompanyTextInfo = (prop: keyof AgPledgeCertificateCompanyRegistered) => {
    return (event: React.ChangeEvent<HTMLInputElement>): void => {
      const updatedCompanyData = {
        ...companyData,
        [prop]: event.target.value
      };
      setCompanyData(updatedCompanyData);
      onCompanyInfoUpdated(updatedCompanyData);
    };
  };

  const updateCompanyNumberInfo = (prop: keyof AgPledgeCertificateCompanyRegistered) => {
    return (value: number | null): void => {
      const updatedCompanyData = {
        ...companyData,
        [prop]: value || 0
      };
      setCompanyData(updatedCompanyData);
      onCompanyInfoUpdated(updatedCompanyData);
    };
  };

  return (
    <Fieldset label={utils.text.toTitleCase(title)}>
      <GridContainer columns={2}>
        <Input
          label={i18next.t('creditor')}
          name="creditor"
          onChange={updateCompanyTextInfo('creditor')}
          value={companyData.creditor}
          sizeVariant="slim"
        />
        <Input
          label={i18next.t('emitter')}
          name="emitter"
          onChange={updateCompanyTextInfo('emitter')}
          value={companyData.emitter}
          sizeVariant="slim"
        />
        <InputNumberMask
          label={i18next.t('volumeBags')}
          name="volumeBags"
          onNumberChange={updateCompanyNumberInfo('volume')}
          numberValue={Number(companyData.volume) || 0}
          sizeVariant="slim"
        />
        <InputNumberMask
          label={i18next.t('pledgeArea')}
          name="pledgeArea"
          onNumberChange={updateCompanyNumberInfo('pledgeArea')}
          numberValue={Number(companyData.pledgeArea) || 0}
          sizeVariant="slim"
        />
        <Input
          label={i18next.t('matricula')}
          name="matricula"
          onChange={updateCompanyTextInfo('matricula')}
          value={companyData.matricula}
          sizeVariant="slim"
        />
        <Input
          label={i18next.t('additionalInformation')}
          name="additionalInformation"
          onChange={updateCompanyTextInfo('additionalInformation')}
          value={companyData.additionalInformation}
          sizeVariant="slim"
        />
      </GridContainer>
    </Fieldset>
  );
};
